export default __webpack_public_path__ + "static/media/logoWebsite.06817180.png";